import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '../ui/button'
import { useQueryState } from 'nuqs'
import { useState } from 'react'
import TrialPlansModal from './trial-plans-modal'

export enum TrialLimitType {
  RANCH_LIMIT = 'ranch-limit', // done
  PARCEL_QUERY_LIMIT = 'parcel-query-limit', //done
  CRITERIA_SEARCH_LIMIT = 'criteria-search-limit', //done
  FILTER_RESULTS_LIMIT = 'filter-results-limit', // done
  REPORTS_NOT_INCLUDED = 'reports-not-included', //done
  REPORTS_MENU_NOT_INCLUDED = 'reports-menu-not-included', //done
}
const limitContent = {
  [TrialLimitType.RANCH_LIMIT]: {
    title: 'Ranch Limit Reached',
    body: (
      <p>
        Your free trial is limited to <b>2 ranches</b>. To create more ranches,
        please select a plan.
      </p>
    ),
  },
  [TrialLimitType.PARCEL_QUERY_LIMIT]: {
    title: 'Parcel Query Limit Reached',
    body: (
      <p>
        Your free trial is limited to <b>100 parcel queries</b>. To continue
        your query, please select a plan.
      </p>
    ),
  },
  [TrialLimitType.CRITERIA_SEARCH_LIMIT]: {
    title: 'Criteria Search Limit Reached',
    body: (
      <p>
        Your free trial is limited to <b>10 unique searches by criteria</b>. To
        keep searching, please select a plan.
      </p>
    ),
  },
  [TrialLimitType.FILTER_RESULTS_LIMIT]: {
    title: 'Filter Results Limit Reached',
    body: (
      <p>
        Your free trial is limited to <b>10 search results per search</b>. To
        see more results per search, please select a plan.
      </p>
    ),
  },
  [TrialLimitType.REPORTS_NOT_INCLUDED]: {
    title: 'Reports Not Included',
    body: (
      <p>
        Your Free Trial does not include any reports. Click the link below to
        download a sample ranch report:
      </p>
    ),
  },
  [TrialLimitType.REPORTS_MENU_NOT_INCLUDED]: {
    title: 'Reports Not Included',
    body: (
      <p>
        Your Free Trial does not include any reports. Click the link below to
        download a sample ranch report:
      </p>
    ),
  },
}

export const TRIAL_LIMIT_QUERY_KEY = 'trial-limit'

export default function TrialLimitModal() {
  const [isOpenTrialPlans, setIsOpenTrialPlans] = useState(false)
  const [applyDiscount] = useState(false)
  const [trialLimitState, setTrialLimitState] = useQueryState(
    TRIAL_LIMIT_QUERY_KEY
  )

  const onOpenChange = (open: boolean) => {
    if (!open) {
      setTrialLimitState(null)
    }
  }
  const config = limitContent[trialLimitState as TrialLimitType]

  const handleViewPlans = () => {
    setIsOpenTrialPlans(true)
    setTrialLimitState(null)
  }

  const handleDownloadSampleReport = async () => {
    // Assuming the PDF is in public/reports/
    const reportUrl = '/data/Sample Hydra Score Ranch Report.pdf'
    const link = document.createElement('a')
    link.href = reportUrl
    // This attribute tells the browser to download the file instead of navigating to it
    link.setAttribute('download', 'Sample Hydra Score Ranch Report.pdf')
    // Append to the document is necessary for Firefox
    document.body.appendChild(link)
    link.click()
    // Clean up by removing the link
    document.body.removeChild(link)
  }

  return (
    <>
      <Dialog open={Boolean(trialLimitState)} onOpenChange={onOpenChange}>
        <DialogContent showClose className="max-w-[440px] !p-8 rounded-lg">
          <DialogHeader>
            <DialogTitle className="md:text-2xl">{config?.title}</DialogTitle>
          </DialogHeader>
          <div>
            <p>{config?.body}</p>
            {(trialLimitState === TrialLimitType.REPORTS_MENU_NOT_INCLUDED ||
              trialLimitState === TrialLimitType.REPORTS_NOT_INCLUDED) && (
              <>
                <Button
                  variant={'ghost'}
                  className="px-0 w-full flex justify-center"
                  onClick={handleDownloadSampleReport}
                >
                  Sample Hydra Score Ranch Report
                </Button>
                {(trialLimitState === TrialLimitType.REPORTS_MENU_NOT_INCLUDED) && (<p>To run reports, please select a plan.</p>)}
                {(trialLimitState === TrialLimitType.REPORTS_NOT_INCLUDED) && (<p>To continue running your report, please select a plan.</p>)}
              </>
            )}
          </div>
          <DialogFooter className="flex sm:flex-col gap-4">
            <Button className="h-14 w-full text-lg" onClick={handleViewPlans}>
              View Plans
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <TrialPlansModal
        isOpen={isOpenTrialPlans}
        isDiscount={applyDiscount}
        onOpenChange={setIsOpenTrialPlans}
      />
    </>
  )
}
